export default "__VITE_ASSET__CBG_IMgo__"